import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// API/Components/Resources
import axiosInstance from '../components/axios';
import UnitIcon from '../components/unit_icon';

// MaterialUI
import Container from '@mui/material/TableContainer';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Grid from '@mui/material/Grid';


function StringDataLoading(Component) {
	return function DataLoadingComponent({ isLoading, ...props }) {
		if (!isLoading) return <Component {...props} />;
		return (
			<Box
				sx={{
					bgcolor: '#FFFFFF44',
					border: 1,
					borderColor: '#CCCCCC',
					borderRadius: 1,
					height: '100%'
				}}
			>
				<Grid container>
					<Grid container>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
					</Grid>
					<Grid container>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
					</Grid>
					<div height='15px'/>
					<Grid container>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
					</Grid>
					<Grid container>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
					</Grid>
					<div height='15px'/>
					<Grid container>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
					</Grid>
					<Grid container>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
					</Grid>
					<div height='15px'/>
					<Grid container>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
					</Grid>
					<Grid container>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
						<Skeleton sx={{ mx: 1, my: 1 }} variant="rounded" width={50} height={50}/>
					</Grid>
				</Grid>
			</Box>
		);
	};
}

function StringMap(props) {
	const {
		locationNum,
		stringNumber,
		numberUnits,
		unitShape,
		numberColumns,
		numberRows,
		units,
		scale,
	} = props;
	const [tableData, setTableData] = useState([]);
	const [stringData, setStringData] = useState({
		locationNumber: locationNum,
		stringNumber: stringNumber,
		numberUnits: numberUnits,
	});

	const cellSize = 35 * scale;

	useEffect(() => {
		const unitTable = buildUnitTable(unitShape, numberColumns, numberRows, units);
		setTableData(unitTable);
		setStringData({
			locationNumber: locationNum,
			stringNumber: stringNumber,
			numberUnits: numberUnits
		});
	}, []);

	// Function to process the table data and fill empty rows and columns
	const buildUnitTable = (unitShape, numberColumns, numberRows, units) => {

		// Create a 2D array to store the table data
		const table = [];
		if (numberColumns && numberColumns) {
			for (let i = 0; i <= numberRows; i++) {
				table[i] = new Array(numberColumns + 1).fill(null);
			}
		}

		if (table.length > 0 && units) {
			// Fill the table with the objects based on their row and column positions
			units.forEach(unit => {

				// Set unit shape. If square, don't rotate. If not square and rotated, change between horiz/vert
				let shape = unitShape;
				if (unitShape !== 0 && unit.unit_rotation > 0) {
					shape = (unitShape === 1) ? 2 : 1;  // Switch between horiz/vert
				}

				let unitObj = {
					"unit_number": unit.unit_number,
					"unit_shape": shape,
					"unit_status": unit.status,
					"unit_comments": unit.unit_comments
				};

				table[unit.unit_position_row][unit.unit_position_col] = unitObj;
			});
		}

		return table;
	};

	return (
		<Container align="center">
			<Box overflow="auto">
				<table>
					<tbody>
						{tableData.map((row, rowIndex) => (
							<tr key={rowIndex}>
							{row.map((cell, columnIndex) => (
								<td key={rowIndex + "," + columnIndex} style={{
									width: cellSize,
									height: cellSize,
								}}>
								{cell && (
									<UnitIcon
										locationNum={locationNum}
										stringNum={stringData.stringNumber}
										unitNum={cell.unit_number}
										unitShape={cell.unit_shape}
										unitState={cell.unit_status}
										unitAlarms={[]}
										scale={scale}
									/>
								)}
								</td>
							))}
							</tr>
						))}
					</tbody>
				</table>
			</Box>
		</Container>
	);
}

export default function LoadStringMap(props) {
	
	const { locationNum, stringNum, scale = 1.0 } = props;

	const StringMapLoading = StringDataLoading(StringMap);
	const [stringState, setStringState] = useState({
		isLoading: true,
		locationNum: locationNum,
		stringNumber: stringNum,
		numberUnits: 0,
		unitShape: 0,
		numberColumns: 0,
		numberRows: 0,
		units: [],
		scale: scale,
	});
	
	const navigate = useNavigate();

	useEffect(() => {
		axiosInstance.get(`/loc/${locationNum}/status/string_${stringNum}`)
			.then(res => {
				const stringData = res.data;
				setStringState({
					isLoading: false,
					locationNum: locationNum,
					stringNumber: stringData.string_number,
					numberUnits: stringData.number_units,
					unitShape: stringData.unit_shape,
					numberColumns: stringData.number_columns,
					numberRows: stringData.number_rows,
					units: stringData.units,
					scale: scale
				})
			})
			.catch(err => {
				console.error("Error fetching string status data: ", err);
				navigate('/404');
			});
	}, [stringNum]);

	return (
		<StringMapLoading
			isLoading={stringState.isLoading}
			locationNum={stringState.locationNum}
			stringNumber={stringState.stringNumber}
			numberUnits={stringState.numberUnits}
			unitShape={stringState.unitShape}
			numberColumns={stringState.numberColumns}
			numberRows={stringState.numberRows}
			units={stringState.units}
			scale={stringState.scale}
		/>
	);
}